import type {
  CoordenadorAvisoResumo,
  CoordenadorAvisosFiltros,
  CoordenadorAvisosResponse,
} from '@/interfaces/coordenador/avisos';
import api from './api';

export default {
  async getAvisos(params: CoordenadorAvisosFiltros) {
    return api.get<CoordenadorAvisosResponse>('/coordenador/avisos', { params });
  },

  async getResumo(cursoId?: number) {
    return api.get<CoordenadorAvisoResumo>('/coordenador/avisos/resumo', {
      params: cursoId ? { curso_id: cursoId } : undefined,
    });
  },

  async exportarCsv(params: CoordenadorAvisosFiltros) {
    return api.get<Blob>('/coordenador/avisos/exportar-csv', {
      params,
      responseType: 'blob',
    });
  },
};
